import { atom, SetStateAction } from 'jotai';
import { createPaginationAtoms } from './utils/filtersFactory';
import { atomWithStorage, createJSONStorage, RESET } from 'jotai/utils';
import { isEqual } from 'lodash';
import { focusAtom } from 'jotai-optics';
import { ProductSumaryInnerColumnSorting } from 'products/productsSummary/constants/productSummaryConstant';

export const {
  rowsPerPageFilterAtom: productSummaryRowsPerPageFilterAtom,
  pageFilterAtom: productSummaryPageFilterAtom,
} = createPaginationAtoms();

type ProductSummaryAtomValues = { account: string | null };

const INITIAL_FILTER_VALUES = {
  account: null,
};

const initialProductSummaryFiltersAtom = atom<ProductSummaryAtomValues>(INITIAL_FILTER_VALUES);

export const productSummaryFiltersAtom = atom(
  (get) => get(initialProductSummaryFiltersAtom),
  (get, set, newValue: SetStateAction<ProductSummaryAtomValues> | typeof RESET) => {
    const currentFilters = get(initialProductSummaryFiltersAtom);
    if (!isEqual(currentFilters, newValue)) {
      set(productSummaryPageFilterAtom, 0);
    }

    if (newValue === RESET) {
      return set(initialProductSummaryFiltersAtom, INITIAL_FILTER_VALUES);
    }

    return set(initialProductSummaryFiltersAtom, newValue);
  },
);

export const accountsProductSummaryAtom = focusAtom(productSummaryFiltersAtom, (optic) =>
  optic.prop('account'),
);

const atomLocalStorage = createJSONStorage<ProductSumaryInnerColumnSorting>(() => localStorage);

const STORAGE_VERSION = 'v1';
const STORAGE_NAME = `product-summary-order`;
const STORAGE_KEY = `${STORAGE_VERSION}-${STORAGE_NAME}`;

export const productSummarySortingAtomWithStorage =
  atomWithStorage<ProductSumaryInnerColumnSorting>(
    STORAGE_KEY,
    {
      columnName: 'bundleProductCode',
      sort: 'asc',
    } as ProductSumaryInnerColumnSorting,
    atomLocalStorage,
    { getOnInit: true },
  );
